import styled, { css } from 'styled-components';
import { remCalc, layout, media } from '@prisjakt/ui-base';

const pageContentGutterBreakpoint = `${1200 - 1}px`;
const takeOverHeight = '900px';
const takeOverTopMarginVal = 120; // @TODO: Is this market specific?
const outsiderMinWidth = '200px';
const sidebarContentWidth = layout.sidebarContentWidth.desktop.value;
const sidebarMenuWidth = layout.sidebarMenuWidth.desktop.value;

const pageWithSidebarContent =
  layout.pageContent.maxWidth.value +
  layout.pageContent.gutter.value +
  (sidebarContentWidth + sidebarMenuWidth) * 2;

type ContentProps = {
  takeover?: boolean;
  wideContent?: boolean;
  hasAds?: boolean;
  alignLeft?: boolean;
};

export const Content = styled.div<ContentProps>(
  props => css`
    width: 100%;
    max-width: ${remCalc(1000)};
    padding-left: 0;
    padding-right: 0;
    margin-right: ${props.alignLeft ? 'auto' : 0};

    ${props.hasAds &&
      css`
        @media ${`screen and (max-width: ${pageContentGutterBreakpoint})`} {
          /* Center content when the outsider ad is hidden */
          margin-left: ${props.takeover ? 0 : 'auto'};
          margin-right: auto;
        }
      `}

    ${props.wideContent &&
      css`
        max-width: none;
      `}

    ${props.takeover &&
      css`
        min-height: ${takeOverHeight};
        background-color: ${props.theme.bg.primary};
        position: relative;
        /* @NOTE: Hardcoded breakpoint based on panorama_top visible width limit */
        @media ${'screen and (min-width: 862px)'} {
          margin-top: ${`${takeOverTopMarginVal +
            layout.pageContent.gutter.value}px`};
        }
      `}
  `
);

type WrapperProps = {
  responsiveMode?: boolean;
};
export const Wrapper = styled.div<WrapperProps>(
  props => css`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: center;
    align-items: center;

    ${media.largeUp`
      ${props.responsiveMode &&
        css`
          min-width: ${layout.siteWidth.rem};
        `}
    `};
  `
);

type TopAdsProps = {
  takeover?: boolean;
};
export const TopAds = styled.aside<TopAdsProps>`
  ${props =>
    props.takeover &&
    css`
      position: absolute;
      top: 0;
      left: 0;
      z-index: 0;

      & > div {
        overflow: hidden;
        max-width: 1600px;
        margin-left: -200px;
        width: calc(100vw + 200px);
      }
    `}
`;

type OutsiderAdsProps = {
  takeover?: boolean;
};

export const OutsiderAds = styled.aside<OutsiderAdsProps>`
  padding-top: ${layout.pageContent.gutter.rem};
  position: relative;
  align-self: stretch;
  margin-bottom: ${layout.pageContent.gutter.rem};
  min-width: ${outsiderMinWidth};
  max-width: 250px;
  width: 100%;

  ${props =>
    props.takeover &&
    css`
      margin-top: ${takeOverHeight};
    `}
`;

type PageContentProps = {
  leftSidebarExperiment?: boolean;
  responsiveMode?: boolean;
};
export const PageContent = styled.div<PageContentProps>`
  width: 100%;
  max-width: ${layout.pageContent.maxWidth.value}px;
  position: relative;
  margin-right: auto;
  margin-left: 0;

  /* Align page content with header content when it exceeds the open sidebar */
  @media ${`(min-width: ${pageWithSidebarContent}px)`} {
    ${props =>
      props.responsiveMode &&
      css`
        margin-left: calc(
          ((100vw - ${layout.pageContent.maxWidth.rem}) / 2) -
            ${sidebarContentWidth +
              sidebarMenuWidth +
              layout.pageContent.gutter.value}px
        );
      `}
  }

  ${media.mediumDown`
    margin-left: auto;
  `};

  @media ${`screen and (min-width: ${pageContentGutterBreakpoint})`} {
    ${props =>
      props.responsiveMode &&
      css`
        display: flex;
        align-items: flex-start;
        justify-content: center;
      `}
  }

  @media ${`screen and (max-width: ${pageContentGutterBreakpoint})`} {
    ${OutsiderAds} {
      display: none;
    }
  }
`;
